export interface PrefixOverrideWarningInput {
  selectedPrefix?: string | null;
  computedPrefix?: string | null;
}

export interface PrefixOverrideWarningDetails {
  shouldWarn: boolean;
  selectedPrefix: string | null;
  computedPrefix: string | null;
}

const normalizePrefix = (prefix?: string | null): string | null => {
  const normalized = prefix?.trim().toUpperCase();
  return normalized || null;
};

export const getPrefixOverrideWarningDetails = ({
  selectedPrefix,
  computedPrefix,
}: PrefixOverrideWarningInput): PrefixOverrideWarningDetails => {
  const normalizedSelectedPrefix = normalizePrefix(selectedPrefix);
  const normalizedComputedPrefix = normalizePrefix(computedPrefix);

  return {
    shouldWarn:
      !!normalizedSelectedPrefix &&
      !!normalizedComputedPrefix &&
      normalizedSelectedPrefix !== normalizedComputedPrefix,
    selectedPrefix: normalizedSelectedPrefix,
    computedPrefix: normalizedComputedPrefix,
  };
};
